class exports.DialogAddMake_Handler extends DialogHandler
    constructor: () ->
        super()

        @subtypeId = null
        @isforcontroll = false
        @modalOptions = backdrop: 'static'


    init: () ->
        @classes = 'smaller_dialog'
        @refreshNavHandler = false

        if @isforcontroll
            @layoutUrl = 'backend/grower/machinery/load-layout-addcomake'
        else
            @layoutUrl = 'backend/grower/machinery/load-layout-addmake'

        @loadLayoutPostOptions = subtype_id: @subtypeId

        @createDialog(@extraData.loadLayout ? {})


    afterLoadLayout: () ->
        @openDialog()


    submitAction: () ->
        @save('Saving...')

